export function inputValidation(input) {
  const { value, validations } = input;
  return validations.reduce((message, validation) => {
    if (message) return message;
    const { type, pattern, errorMessage, count } = validation;
    if (type === "required" && !value) {
      return errorMessage;
    }
    if (type === "pattern" && !pattern.test(value)) {
      return errorMessage;
    }
    if (type === "minLength" && value.length < count) {
      return errorMessage;
    }
    if (type === "maxLength" && value.length > count) {
      return errorMessage;
    }
    return "";
  }, "");
}